import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
  lastNameColumn,
  firstNameColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import { fetchRolesList } from "../../../../../store/CommonSlice";
import { dateFormatter } from "../../../../../config/Global";
import { dateFormats } from "../../utils/constants";

const useColumnDefs = () => {
  const dispatch = useAppDispatch();


  const campaignNameColumn: ColDef = {
    field: "campain_name",
    headerName: "Subscription Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.campain_name);
    },
  };

  const companyNameColumn: ColDef = {
    field: "company_name",
    headerName: "Customer Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.company_name);
    },
  };

  const startDateColumn: ColDef = {
    field: "start_date",
    headerName: "Start Date",
    // filter: "agDateColumnFilter",
    cellRenderer: (props: any) => {
      return props.data.start_date
        ? dateFormatter(props.data.start_date, dateFormats.start_date)
        : "N/A";
    },
    filterValueGetter: (props: any) => {
      return props.data.start_date
        ? dateFormatter(props.data.start_date, dateFormats.start_date)
        : "N/A";
    },
    valueGetter: (props: any) => {
      return props.data.start_date
        ? dateFormatter(props.data.start_date, dateFormats.start_date)
        : "N/A";
    },
  };

  const EndDateColumn: ColDef = {
    field: "end_date",
    headerName: "End Date",
    // filter: "agDateColumnFilter",
    cellRenderer: (props: any) => {
      // return renderNA(props.data.dob);
      return props.data.end_date
        ? dateFormatter(props.data.end_date, dateFormats.end_date)
        : "N/A";
    },
    filterValueGetter: (props: any) => {
      return props.data.end_date
        ? dateFormatter(props.data.end_date, dateFormats.end_date)
        : "N/A";
    },
    valueGetter: (props: any) => {
      return props.data.end_date
        ? dateFormatter(props.data.end_date, dateFormats.end_date)
        : "N/A";
    },
  };


  const SpecialAccessCodeColumn: ColDef = {
    field: "special_flag",
    headerName: "Access Code Type",
    cellRenderer: (props: any) => {
      return renderNA(props.data.special_flag == 1 ? 'Internal' : 'Regular');
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data.special_flag == 1 ? 'Internal' : 'Regular');
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props.data.special_flag == 1 ? 'Internal' : 'Regular');
    },
    valueGetter: (props: any) => {
      return props.data.special_flag == 1 ? 'Internal' : 'Regular';
    },


  };


  const AccessCodeCountColumn: ColDef = {
    field: "access_code_count",
    headerName: "Access Code Count",
    cellRenderer: (props: any) => {
      return renderNA(props.data.access_code_count);
    },
  };

  const UsedAccessCodeCountColumn: ColDef = {
    field: "used_access_code_count",
    headerName: "Used Access Code Count",

    cellRenderer: (props: any) => {
      // return props.data.special_flag && props.data.special_flag==1 ? renderNA(false) : props.data.used_access_code_count;
      return props.data.used_access_code_count;
    },
  };

  const isCompletedColumn: ColDef = {
    field: "is_completed",
    headerName: "Is Completed",
    cellRenderer: (props: any) => {
      return renderNA(props.data.is_completed);
    },
  };


  const descriptionColumn: ColDef = { ...generateColumn("Description", "description") };



  const industryColumn: ColDef = {
    field: "industry_name",
    headerName: "Industry Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.industry_name);
    },
  };


  return [
    idColumn,
    campaignNameColumn,
    companyNameColumn,
    industryColumn,
    { ...startDateColumn, ...setDateFilterDefs() },
    { ...EndDateColumn, ...setDateFilterDefs() },
    descriptionColumn,

    SpecialAccessCodeColumn,
    AccessCodeCountColumn,
    UsedAccessCodeCountColumn,
    isCompletedColumn,
    statusColumn,
    { ...actionColumn, width: 195, minWidth: 195 },
  ];
};

export default useColumnDefs;
